import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { postRequest } from "../functions";

const FALLBACK_IMAGE_URL = "https://www.kaffee-1.de/images/logoperfectmooseverticalblack.png?crc=4231604857";

export const getPrimaryS3ImageKey = (imageValue) => {
  if (!imageValue || imageValue === "null") return "";

  try {
    const parsedValue = typeof imageValue === "string" ? JSON.parse(imageValue) : imageValue;
    return Array.isArray(parsedValue) && parsedValue.length > 0 ? parsedValue[0] : "";
  } catch (_error) {
    return "";
  }
};

export function ImageThumbNailViewer({ s3Key, size = 40 }) {
  const [url, setUrl] = useState(FALLBACK_IMAGE_URL);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (!s3Key) {
      setUrl(FALLBACK_IMAGE_URL);
      return () => {
        isMounted = false;
      };
    }

    async function fetchUrl() {
      try {
        const data = await postRequest(`/api/aws/s3/download`, { keys: [s3Key] });
        if (isMounted) setUrl(data?.[0]?.url || FALLBACK_IMAGE_URL);
      } catch (_error) {
        if (isMounted) setUrl(FALLBACK_IMAGE_URL);
      }
    }

    fetchUrl();

    return () => {
      isMounted = false;
    };
  }, [s3Key]);

  const containerStyle = {
    marginTop: "-3px",
    marginBottom: "-3px",
    padding: "0px",
    overflow: "hidden",
    height: `${size}px`,
    width: `${size}px`,
    position: "relative",
    cursor: "pointer",
  };

  const imageStyleBase = {
    border: "1px solid gray",
    borderRadius: "5px",
    objectFit: "cover",
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
  };

  const imageFullscreenStyle = {
    objectFit: "contain",
    maxHeight: "88vh",
    maxWidth: "88vw",
    width: "auto",
    height: "auto",
    border: "1px solid gray",
    borderRadius: "5px",
    backgroundColor: "white",
    cursor: "zoom-out",
    boxShadow: "0 24px 64px rgba(0, 0, 0, 0.35)",
  };

  const fullscreenBackdropStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    backgroundColor: "rgba(17, 24, 39, 0.72)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    cursor: "zoom-out",
  };

  return (
    <>
      <div style={containerStyle} onClick={() => setIsFullscreen(true)}>
        <img src={url} alt={s3Key || "product"} style={imageStyleBase} />
      </div>

      {isFullscreen &&
        createPortal(
          <div style={fullscreenBackdropStyle} onClick={() => setIsFullscreen(false)}>
            <img
              src={url}
              alt={s3Key || "product"}
              style={imageFullscreenStyle}
              onClick={(event) => {
                event.stopPropagation();
                setIsFullscreen(false);
              }}
            />
          </div>,
          document.body
        )}
    </>
  );
}
